import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { authExist } from "common/helper/utilities";

const SuperPrivateRoute = ({ component: Component, ...rest }) => {
    const userProfileExist = rest.userProfile.auth;
    const token = userProfileExist ? rest.userProfile.auth.token : null;
    return <Route {...rest} render={(props) => (authExist(token) ? <Component {...props} /> : <Redirect to="/super-admin" />)} />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.userProfile,
    };
};

export default connect(mapStateToProps, null)(SuperPrivateRoute);
